<template>
  <div class="myfooter">
    <div v-show="!isMobile" class="window-text">
      <el-row type="flex">
        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" class="myfooter_body">
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="myfooter_body_left">
              <h4>关于我们</h4>
              <ul>
                <li @click="goIntroduce">公司简介</li>
                <!-- <li>
                  <a href="https://www.hejunzongda.com/">和君纵达官网</a>
                </li> -->
                <!-- <li>
                  <router-link to="/">加入我们</router-link>
                </li>
                <li>
                  <router-link to="/">联系我们</router-link>
                </li> -->
              </ul>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="myfooter_body_middle">
            <h4>联系方式</h4>
            <ul>
              <!-- <li>联系电话 0512-83669089</li>
              <li>商务合作 sqzczy@hjzddata.com</li> -->
              <li>联系邮箱 market@hjzddata.com</li>
            </ul>
          </div>
          </el-col>
          
        </el-col>
      </el-row>
    </div>
    <div v-show="isMobile" class="mobile-text">
      <el-row type="flex">
        <el-col :xs="16">
          <div class="mobile-footer-left">
            <h4>关于我们</h4>
            <ul>
              <li @click="goIntroduce">公司简介</li>
              <!-- <li>
                <a href="https://www.hejunzongda.com/">和君纵达官网</a>
              </li> -->
              <!-- <li>
                <router-link to="/">加入我们</router-link>
              </li>
              <li>
                <router-link to="/">联系我们</router-link>
              </li> -->
            </ul>
            <ul>
              <!-- <li>联系电话 0512-83669089</li>
              <li>商务合作 sqzczy@hjzddata.com</li> -->
              <li>联系邮箱 market@hjzddata.com</li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
      <div class="copyright">
        <span>Copyright © 2018 上海望潮数据科技有限公司版权所有 
          <a class="copy-link" target="_blank" href="https://beian.miit.gov.cn/">沪ICP备19000499号</a>
        </span>
      </div>
  </div>
</template>

<script>
import ResizeEvent from "@/components/resizeEvent"

export default {
  name: "myFooter",
  data() {
    return {};
  },
  mixins:[ResizeEvent],
  methods: {
    goIntroduce() {
      this.$store.state.anchorFlag = true;
      console.log(this.$anchorFlag);
      this.$anchorFlag = true;
      console.log("footer中" + this.$anchorFlag);
      this.$router.push({ name: "introduce" });
    },
    handleResize(){
      this.isMobile = document.body.clientWidth < 1000;
    }
  }
};
</script>
<style lang="scss">
.myfooter {
  width: 100%;
  background-color:rgba(21, 21, 21, 1);
  border-top: 1px solid white;
    .myfooter_body {
      width:  60rem;
      display: flex;
      justify-content: space-between;
      flex-flow: row wrap;
      margin: 2rem auto 2rem;
      font-size: 0.6rem;
      line-height: 1.95rem;
      color: #fff;
      h4 {
        font-size: 1rem;
        margin-bottom: 1rem;
      }
      .myfooter_body_left {
        margin: 0 auto;
        width: 160px;
        ul {
          li {
            display: inline-block;
            width: 80px;
            a {
              color: #fff;
            }
          }
          li:hover {
            cursor: pointer;
          }
        }
      }
      .myfooter_body_middle {
        margin: 0 auto;
        width: 10rem;
      }
      .myfooter_body_right {
        width:160px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        h4{
          margin-bottom: 30px;
        }
        img {
          width: 4.25rem;
          height: 4.25rem;
        }
      }
    }
    .copyright {
      height: 0.75rem;
      font-size: 0.6rem;
      text-align: center;
      padding-bottom:2rem;
      color: #fff;
      .copy-link{
        text-decoration: none;
        color: #fff;
      }
    }
}
.mobile-text{
  color: #fff;
  padding: 20px;
  h4{
    font-size: 16px;
    margin-bottom: 8px;
  }
  .mobile-footer-left{
    ul li{
      line-height: 16px;
      a{color: #fff;}
    }
  }
  .mobile-footer-right{
    img{
      width: 80px;
    }
  }
}
</style>